export default {
    "/": {
        "title": "Taoify - 中国の商品を世界に売るためのクロスボーダーECサイト構築プラットフォーム",
        "desc": "Taoifyは、サイト構築、翻訳、商品登録、物流、決済、マーケティングを1つのバックオフィスで管理。18人のAIスタッフがサポートし、20言語に対応して中国の商品を世界中へと販売します。"
    },
    "/feature": {
        "title": "機能 · 店舗開設に必要なものはすべてこのページに · Taoify",
        "desc": "サイト構築、翻訳、商品登録、発送、決済、顧客獲得——Taoifyはクロスボーダー販売に必要な15のモジュールを1つのバックオフィスに集約。複数のツールを組み合わせる必要はありません。"
    },
    "/ai-staff": {
        "title": "AIスタッフ · 18人のAIスタッフ、特にトラフィック獲得に特化したメンバーが活躍 · Taoify",
        "desc": "18人のAIスタッフの中でも、成長チームの5人が「訪問者不足」の問題解決に専念：12項目の店舗診断、30日間のマーケティングプラン、1つの商品を9つのチャネル向けにリライト、自動メールマーケティングで購入履歴のある顧客を呼び戻します。"
    },
    "/logistics": {
        "title": "クロスボーダーロジスティクス · あなたの手元からお客様の手元まで · Taoify",
        "desc": "輸出、通関、主要輸送路、最終配送、3つのルートから商品と納期に応じて選択可能。YunExpress、U-Buy、4PXと連携し、ラベル作成、追跡情報、異常処理が1つのバックオフィスで完結。"
    },
    "/payment": {
        "title": "決済と精算 · お客様にとって最も便利な方法でお支払い · Taoify",
        "desc": "PayPal、Stripe、クレジットカード、Alipayをすぐに利用可能。外貨での収入を人民元で引き出し、T+7で精算。手数料と到着時間は明確に表示されます。"
    },
    "/pricing": {
        "title": "価格 · サブスクリプションプラン + ステップコミッション · Taoify",
        "desc": "店舗はサブスクリプションプランによって課金：ベーシック版 $15/月、スタンダード版 $29/月、プレミアム版 $59/月。四半期または年間契約でさらにお得。取引手数料は月間売上額に応じたステップ制、最低3%から。"
    },
    "/cases": {
        "title": "セラー事例 · みんな同じことをしている · Taoify",
        "desc": "義烏のアクセサリー、深圳の3C製品、広州の衣料品、ドイツ、アメリカ、フランスのセラー——6人の異なる出発点を持つ人々が、同じ方法で成功を収めています。"
    },
    "/sign-up": {
        "title": "店舗開設 - Taoifyで無料登録",
        "desc": "10分でブランドサイトを構築。コード不要、全機能試用可能、完全なエコシステム。今すぐTaoifyに登録し、クロスボーダーECの旅を始めましょう。"
    },
    "/for-china-sellers": {
        "title": "中国のセラー向け · 商品選定と価格設定はあなた、その他は私たちが · Taoify",
        "desc": "サイト構築、翻訳、送料計算、ラベル作成、顧客対応——これらの煩わしい作業はプラットフォームが代行します。サブスクリプションプラン + ステップコミッション（最低3%）。"
    },
    "/for-global-sellers": {
        "title": "海外セラー向け：中国の商品棚から選んで、あなたの店で販売 · Taoify",
        "desc": "在庫リスクなし：中国の供給網から商品を選んで販売し、注文後は中国の倉庫から直接発送。差額利益を得られます。BuyLinkを使えば1688や淘宝のリンクを自分の商品に変えることもできます。"
    },
    "/template-index": {
        "title": "テンプレートマーケット - Taoifyのプロフェッショナルウェブサイトテーマ",
        "desc": "あらゆるプロジェクトに適したプロフェッショナルなウェブサイトテーマ。多数の業界テンプレートを無料で使用可能、ニーズに合わせてブランドイメージと機能をカスタマイズ。"
    },
    "/question": {
        "title": "ヘルプセンター · 問題があればまずここをチェック · Taoify",
        "desc": "店舗開設、デザイン、商品登録、注文・物流、決済、マーケティング、アカウント権限——よくある質問はカテゴリー別に整理されています。見つからない場合はチケットを提出してください。"
    },
    "/about-us": {
        "title": "Taoifyについて · 私たちが何を成し遂げようとしているのか",
        "desc": "Taoifyは、サイト構築、翻訳、商品登録、物流、決済、マーケティングを1つのバックオフィスで完結するクロスボーダー販売者のための包括的なプラットフォームです。"
    },
    "/privacy-policy": {
        "title": "プライバシーポリシー · Taoify",
        "desc": "Taoify がどのようにあなたの個人情報を収集、使用、保存し、保護するか、またあなたが自分のデータに対して持つ権利について。"
    },
    "/terms-service": {
        "title": "サービス条項 · Taoify",
        "desc": "Taoify プラットフォームのサービス利用に関する条件：アカウント、ストア、注文、決済、責任の所在。"
    },
    "/consumer-agreement": {
        "title": "返金ポリシー · Taoify",
        "desc": "Taoifyプラットフォームでの注文に関する返金とアフターサービスのルール：申請条件、処理時間、および入金方法について。"
    },
    "/user-agreement": {
        "title": "利用規約 · Taoify",
        "desc": "Taoifyの登録と利用前にご確認ください：アカウント登録、店舗運営規範、プラットフォームサービス説明。"
    }
}
